// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, globalActions } from "src/actions";

import { IProps, Text } from "@blueprintjs/core";

import { FloatingInput } from 'src/components';

import { DuoButtons, ToggleButtons } from 'src/components';

import { MPDHiddenScrollContainer } from 'src/mpd-library';

import { SettingsControlProperty } from '../components';

import "./styles.css";

interface IGroupsSettingsAddProps extends IProps {
  itemType: string;
  routeProps: any;
  manage?: any;
  groupId?: string;
  groupToEdit?: any;
  onCancelChanges: (pathname: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onSaveChanges: (alertSettingsType: string, manage: any, pathname: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
}

interface IGroupsSettingsAddState {
  manage: any;
  groupToEdit: any;
}

class GroupsSettingsAdd extends React.Component<IGroupsSettingsAddProps, IGroupsSettingsAddState> {
  constructor(props: IGroupsSettingsAddProps) {
    super(props);
    this.updateToolBar = this.updateToolBar.bind(this);
    this.onCancelChanges = this.onCancelChanges.bind(this);
    this.onInputChanged = this.onInputChanged.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.onChangeControl = this.onChangeControl.bind(this);
    const { manage } = this.props;
    let { groupToEdit } = this.props;

    if(groupToEdit === undefined){
      groupToEdit = alertSettingsActions.onInitializeGroupItem();
    }

    this.state = {
        manage,
        groupToEdit
    }
  }

  public componentDidMount() {
    this.updateToolBar(this.props.itemType);
  }

  public componentWillReceiveProps(nextProps: IGroupsSettingsAddProps) {
    if(nextProps.itemType !== this.props.itemType) {
      this.updateToolBar(nextProps.itemType);
    }
  }

  public render() {
    const { className } = this.props;
    const { groupToEdit } = this.state;
    return (
      <MPDHiddenScrollContainer className='group-settings-add-container' yDirection={true}>
        <div className={classNames('group-settings-add-inner-container', className)}>
          <div className='group-settings-information'>
            <Text className='group-settings-add-header'> Group Information </Text>
            <div className='inner-container'>
              <FloatingInput
                autoCapitalize="none"
                autoCorrect="none"
                floatingType="settings"
                value={groupToEdit.title}
                onChange={e => this.onInputChanged(e, "title")}
                placeholder="GROUP NAME"
                tabIndex={1}
              />
              <FloatingInput
                autoCapitalize="none"
                autoCorrect="none"
                floatingType="settings"
                value={groupToEdit.description}
                onChange={e => this.onInputChanged(e, "description")}
                placeholder="GROUP DESCRIPTION"
                tabIndex={1}
              />
            </div>
          </div>
          <div className='group-settings-information'>
            <Text className='group-settings-add-header'> Additional Settings </Text>
            <SettingsControlProperty 
               title='Private Group' 
               subtitle='Private groups can only be added by users that have your pivate group code' 
               switchProps={{
                  checked: groupToEdit.type === 'private',
                  onChange: this.onChangeControl
               }}
            />
          </div>
          </div>
      </MPDHiddenScrollContainer>
    );
  }

  private onChangeControl(event: any) {
    const { groupToEdit } = this.state;
    const { type } = groupToEdit;
    if (type === 'private'){
      groupToEdit.type = 'public';
    }
    else {
      groupToEdit.type = 'private';
    }
    this.setState({ groupToEdit });
  }

  private onInputChanged(event: any, type: string) {
    const { groupToEdit } = this.state;
    const text = event.currentTarget.value;
    groupToEdit[type] = text;
    this.setState({ groupToEdit });
  }

  private onCancelChanges(event: any)  {
    const { itemType, routeProps, onCancelChanges } = this.props;
    const { history } = routeProps;
    const pathname = `/alerts-settings/${itemType}`;
    if(onCancelChanges) {
      onCancelChanges(pathname, history);
    }
  }

  private onSaveChanges(event: any) {
    const { onSaveChanges, itemType, groupId, routeProps } = this.props;
    if(onSaveChanges){
        const { history } = routeProps;
        const { manage, groupToEdit } = this.state;
        const list = manage[itemType].list;
        const id = Math.floor(Math.random()*(999-100+1)+100).toString();
        const index = list.findIndex((listItem:any) => listItem.id === id );
        if(index === -1 && groupId === undefined){
          groupToEdit.id = id;
          list.push(groupToEdit);
          const pathname = `/alerts-settings/${itemType}`;
          onSaveChanges('manage', manage, pathname, history);
        }
        else if(groupId !== undefined){
          const indexNew = list.findIndex((listItem:any) => listItem.id === groupId );
          list[indexNew] = groupToEdit;
          const pathname = `/alerts-settings/${itemType}`;
          onSaveChanges('manage', manage, pathname, history);
        }
    }
  }

  private updateToolBar(text: string) {
    const { groupId } = this.props;
    const topBarProps = {
      className: 'group-settings-add-top-bar',
      leftElement: (
        <ToggleButtons
          label={text.charAt(0).toUpperCase() + text.slice(1) + (groupId ? ' / ' + groupId : ' / New Group')}
          onToggle={this.props.onToggleRightPanel}
          onClose={this.props.onCloseRightPanel}
        />
      ),
      rightElement: (
        <DuoButtons
          firstButtonClick={this.onCancelChanges}
          secondButtonClick={this.onSaveChanges}
          firstButtonText="Cancel"
          secondButtonText="Save"
        />
      )
    };
    if(this.props.onUpdateToolBar){
      this.props.onUpdateToolBar(topBarProps);
    }
  }
}

const mapStateToProps = (state: any) => {
  const {  alertSettings } = state;
  const { manage } = alertSettings;
  return {
    manage
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(
      globalActions.onUpdateToolBar,
      dispatch
    ),
    onCancelChanges: bindActionCreators(
      alertSettingsActions.onCancelChanges,
      dispatch
    ),
    onSaveChanges: bindActionCreators(
      alertSettingsActions.onSaveChanges,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsSettingsAdd);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/groups-settings/group-settings-add.tsx